import filter from 'lodash/filter'
import get from 'lodash/get'
import { createSelector } from 'reselect'

export const completedSelector = statusSelectorFactory('completed')
export const unableSelector = statusSelectorFactory('unable')

function statusSelectorFactory (status) {
  return servicings => filter(servicings, { status })
}

export const getServicesServicings = (state, props) => get(state.servicings, props.servicingId, {}).servicesServicings

export const getCompletedServices = createSelector(
  [getServicesServicings],
  (servicesServicings) => Object
    .keys(servicesServicings)
    .filter(serviceId => servicesServicings[serviceId].completedAt !== null)
    .map(id => parseInt(id))
)




// WEBPACK FOOTER //
// ./src/selectors/servicings-selector.js